@let d = data();

@if (d.select_personneChercherEnfant || d.input_heure) {
<div class="info-row-simple">
  <mat-icon>logout</mat-icon>
  <span>
    @if (d.select_personneChercherEnfant) {
    Venu chercher par <strong>{{ d.select_personneChercherEnfant }}</strong>
    } @else {
    Départ de l'enfant
    }
    @if (d.input_heure) {
    à <strong>{{ d.input_heure | carnetHeure }}</strong>
    }
  </span>
</div>
}

@if (d.input_synthese) {
<div class="synthese-block">
  <div class="synthese-header">
    <mat-icon>summarize</mat-icon>
    <span class="synthese-title">Synthèse de la journée</span>
  </div>
  <p class="synthese-text">{{ d.input_synthese }}</p>
  @if (d.select_userTransmission) {
  <div class="synthese-signature">— {{ d.select_userTransmission }}</div>
  }
</div>
}

@if(d.checkboxb_certification === "1"){
<div class="info-row-simple certification-row">
  <mat-icon>verified</mat-icon>
  <span>La transmission et la restitution orale ont été effectuées par le professionnel.</span>
</div>
}